/**
 * EntityUsers API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  addEntityUser,
  generateEntityUserToken,
  getEntityUsers,
  removeEntityUser,
  updateEntityUserRole,
} from "../generated/entity-users/entity-users";

import { wrapMethod } from "./utils";

export const entityUsers = {
  /** @see getEntityUsers */
  list: wrapMethod(getEntityUsers),

  /** @see addEntityUser */
  addEntityUser: wrapMethod(addEntityUser),

  /** @see updateEntityUserRole */
  update: wrapMethod(updateEntityUserRole),

  /** @see removeEntityUser */
  removeEntityUser: wrapMethod(removeEntityUser),

  /** @see generateEntityUserToken */
  generateEntityUserToken: wrapMethod(generateEntityUserToken),
} as const;

export type EntityUsersApi = typeof entityUsers;
